import {
  Button,
  Div,
  H3,
  Modal,
  ModalIconStyle,
  P,
  PropsModal,
  SuccessToast,
  TrashIcon,
  deleteUserById,
  reportError,
} from '@vgrubs/components';
import { User } from 'components/src/types/user.types';
import { Dispatch, SetStateAction } from 'react';

export const UsersAndAccessDeleteModal = ({
  setLoading,
  modalIsOpen,
  closeModal,
  onSuccess,
}: PropsModal & {
  setLoading: Dispatch<SetStateAction<boolean>>;
  modalIsOpen: User | null;
  onSuccess?: () => void;
}) => {
  const user = modalIsOpen;

  async function handleDeleteUser() {
    if (!user) return;
    try {
      setLoading(true);
      const { data } = await deleteUserById(user.id);
      SuccessToast(data.message);
      onSuccess?.();
    } catch (error) {
      reportError(error);
    } finally {
      setLoading(false);
    }
  }

  return (
    <Modal
      isOpen={!!modalIsOpen}
      closeModal={closeModal}
      logo={false}
      zIndex={111}
    >
      <Div $flex $justifyCenter>
        <ModalIconStyle>
          <TrashIcon />
        </ModalIconStyle>
      </Div>
      <H3 $mb="8">Delete User?</H3>
      <P>Are you sure tou want to delete this user? This cannot be undone.</P>

      <Div $flex $gap="20px" $mt="32">
        <Div $width="50%">
          <Button $selected $w="100%" onClick={handleDeleteUser}>
            Yes
          </Button>
        </Div>
        <Div $width="50%">
          <Button $selected $gray $w="100%" onClick={() => closeModal?.()}>
            No
          </Button>
        </Div>
      </Div>
    </Modal>
  );
};
